import CustomersTable from './table/CustomersTable';
import { CustomerProvider } from 'context/customers/customersContext';
import DeactivateCustomerModal from './dialogs/DeactivateCustomerModal';
import FreezeCustomerModal from './dialogs/FreezeCustomerModal';
import UnfreezeCustomerModal from './dialogs/UnfreezeCustomerModal';
import EditSpendLimitModal from './dialogs/EditSpendLimitModal';

const CustomersSection = () => {
    return (
        <CustomerProvider>
            <CustomersTable />
            <DeactivateCustomerModal />
            <FreezeCustomerModal />
            <UnfreezeCustomerModal />
            <EditSpendLimitModal />
        </CustomerProvider>
    );
};

export default CustomersSection;
